export default "__VITE_ASSET__CwrHPyib__"